<template>
  <scout-form
    :is-modified="!!value || value === 0"
    label="最終ログイン"
  >
    <div class="boss-layout boss-layout-start">
      <div style="min-width: 17em;">
        <input
          :value="value"
          class="boss-input"
          style="width: 8em;"
          placeholder="0〜90から指定"
          type="number"
          max="90"
          min="0"
          data-test="text-box"
          @keypress="onlyNumberInRange($event, 90)"
          @change="$emit('input', $event.target.value || null)"
        >
        <span>日以内</span>
      </div>
      <div>
        <span class="boss-annotation-text">
          ※会員がtypeを利用した最新日時を指定する項目です。（ログイン中）
        </span>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  }
}
</script>
